module.exports = __webpack_public_path__ + "img/report-cover.26d0b630.png";